import React from "react";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";

// cds product logo imports
import slide1 from "../../../../app/assets/images/idea-booster/products/iledger.webp";
import slide2 from "../../../../app/assets/images/idea-booster/products/Intellicue.webp";
import slide3 from "../../../../app/assets/images/idea-booster/products/J&P.webp";
import slide4 from "../../../../app/assets/images/idea-booster/products/Clude.in.webp";
import slide5 from "../../../../app/assets/images/idea-booster/products/mockup.webp";
import slide6 from "../../../../app/assets/images/idea-booster/products/social.webp";
import slide7 from "../../../../app/assets/images/idea-booster/products/bussopi.webp";
import slide8 from "../../../../app/assets/images/idea-booster/products/attesta.webp";

const ourInovations = () => {
  const properties = {
    prevArrow: (
      <button className="cs-btn ib-btn-left">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          class="bi bi-chevron-left"
          viewBox="0 0 16 16"
        >
          <path
            fill-rule="evenodd"
            d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"
          />
        </svg>
      </button>
    ),
    nextArrow: (
      <button className="cs-btn btn-right ib-btn-right">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          class="bi bi-chevron-right"
          viewBox="0 0 16 16"
        >
          <path
            fill-rule="evenodd"
            d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"
          />
        </svg>
      </button>
    ),
  };
  const responsiveSettings = [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 320,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ];
  return (
    <>
      <style jsx>
        {`
          .cust-slider-cont .card {
            border-radius: 15px;
            background: 0 0;
            box-shadow: none;
            padding: 25px;
            margin-right: 20px;
          }
          .cust-slider-cont .card h3 {
            font-size: 24px;
            line-height: 26px;
            color: #fff;
            margin-bottom: 10px;
          }
          .cust-slider-cont .card img {
            height: 300px;
            object-fit: contain;
            margin-bottom: 20px !important;
          }
          button.ib-btn-left.nav svg,
          button.ib-btn-right.nav svg {
            width: 2px;
            scale: 10;
          }
          button.ib-btn-left.nav,
          button.ib-btn-right.nav {
            background: #fff;
            border-radius: 50%;
            color: #030014;
            padding: 10px 18px;
          }
          button.cs-btn.ib-btn-right.nav {
            margin-right: 0;
            right: 50%;
            bottom: -50px;
            transform: translateX(120%);
          }
          button.cs-btn.ib-btn-left.nav {
            margin-right: 0;
            left: 50%;
            bottom: -50px;
            transform: translateX(-120%);
          }
          .product-details p {
            font-size: 20px;
            line-height: normal !important;
          }
        `}
      </style>

      {/* Our Innovations Section Start Here */}
      <div class="wg-result bg-black cust-padding border-line-btm">
        <div class="themesflat-container">
          <div class="row justify-content-center">
            <div class="content text-center">
              <div class="heading-section wow fadeInUp style-2">
                <div class="main-title title">
                  <h2 class="mb-0 section-head">
                    Our <span class="custom-underline">Innovations</span>
                    <br />
                    By Our Experts
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </div>

        <section class="carousel_se_01 bg-black">
          <div class="container cust-slider-cont mb-5">
            <Slide
              className="brand-slider"
              {...properties}
              slidesToScroll={1}
              slidesToShow={2}
              indicators={false}
              duration={700}
              infinite={true}
              pauseOnHover={false}
              autoplay={true}
              responsive={responsiveSettings}
            >
              <div class="card">
                <img src={slide1} alt="Logo" class="img-fluid mb-1" />
                <div className="product-details">
                  <h3 class=" fw-bold">Iledgers (B2B)</h3>
                  <p>
                    Features customizable checklists, photo capture, real-time
                    reporting, and fleet management to improve inspection
                    efficiency.
                  </p>
                </div>
              </div>
              <div class="card">
                <img src={slide2} alt="Logo" class="img-fluid mb-1" />
                <div className="product-details">
                  <h3 class=" fw-bold">Intellicue (B2B)</h3>
                  <p>
                    An education app is a digital tool that enhances learning
                    through interactive lessons, quizzes, and personalized
                    content.
                  </p>
                </div>
              </div>
              <div class="card">
                <img src={slide3} alt="Logo" class="img-fluid mb-1" />
                <div className="product-details">
                  <h3 class=" fw-bold">J&P Hospitality (B2B)</h3>
                  <p>
                    Enhance guest experiences with exceptional service,
                    efficient operations, staff training, resource optimization,
                    and engagement.
                  </p>
                </div>
              </div>
              <div class="card">
                <img src={slide4} alt="Logo" class="img-fluid mb-1" />
                <div className="product-details">
                  <h3 class=" fw-bold">Clued.in (B2B)</h3>
                  <p>
                    Closet: the ultimate app to organize clothes, plan outfits,
                    and enhance your personal style.
                  </p>
                </div>
              </div>
              <div class="card">
                <img src={slide5} alt="Logo" class="img-fluid mb-1" />
                <div className="product-details">
                  <h3 class=" fw-bold">Carfidante (B2B)</h3>
                  <p>
                    Streamline car inspections with custom checklists, real-time
                    reporting, photo capture, and fleet management integration.
                  </p>
                </div>
              </div>
              <div class="card">
                <img src={slide6} alt="Logo" class="img-fluid mb-1" />
                <div className="product-details">
                  <h3 class=" fw-bold">Social lite (B2B)</h3>
                  <p>
                    Make new friends, join events, and find communities. Safe,
                    simple, and personal. Start connecting today!
                  </p>
                </div>
              </div>
              <div class="card">
                <img src={slide7} alt="Logo" class="img-fluid mb-1" />
                <div className="product-details">
                  <h3 class=" fw-bold">Bussopi (B2B)</h3>
                  <p>
                    Bussopi is a reliable app for managing and validating
                    personal information, including legal documents, health
                    data, and personality behavior.
                  </p>
                </div>
              </div>
              <div class="card">
                <img src={slide8} alt="Logo" class="img-fluid mb-1" />
                <div className="product-details">
                  <h3 class=" fw-bold">Attesta AI (Product)</h3>
                  <p>
                    A document reader is a software application for displaying
                    and managing digital documents in various formats like PDF
                    and DOCX.
                  </p>
                </div>
              </div>
            </Slide>
          </div>
        </section>
      </div>
      {/* Section End Here */}
    </>
  );
};

export default ourInovations;
